import React from 'react';

import lottie from 'lottie-web/build/player/lottie_light';
import styled from 'styled-components';

import { mobile } from '~/techstyle-shared/react-components';

import unlockAnimation from './unlock_animation.json';

const Container = styled.div`
  position: relative;
  width: 50px;
`;

const LoyaltyUnockingIconWrapper = styled.div`
  width: 80px;
  position: absolute;
  top: -48px;
  left: -10px;
  ${mobile`
    left: -15px;
  `}
`;

const LoyaltyUnockingIcon = () => {
  React.useEffect(() => {
    const animation = lottie.loadAnimation({
      container: document.querySelector('#exlusive-product-unlock-animation'),
      animationData: unlockAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
    });

    return () => animation.destroy();
  }, []);

  return (
    <Container>
      <LoyaltyUnockingIconWrapper id="exlusive-product-unlock-animation" />
    </Container>
  );
};

export default LoyaltyUnockingIcon;
